import { useEffect } from 'react'

import { useWindowSize } from '@react-hook/window-size'
import { useDispatch, useSelector } from 'react-redux'

import {
  closeTraceLogDrawer,
  selectIncidentTraceLogDrawerState,
} from '@/redux/ui/uiSlice'

import {
  INCIDENT_DRAWER_WIDTH,
  IncidentDrawerContainer,
} from '../../components/IncidentDrawerContainer'
import { EventFiltersI } from '../types/types'
import { TraceLogContent } from './TraceLogContent'

export const TRACELOG_DRAWER_WIDTH = 445
export const DRAWER_BREAKPOINT = INCIDENT_DRAWER_WIDTH + TRACELOG_DRAWER_WIDTH

export const TraceLogDrawer = ({ incident }: EventFiltersI) => {
  const isOpen = useSelector(selectIncidentTraceLogDrawerState)?.isOpen
  const dispatch = useDispatch()
  const [width] = useWindowSize()

  useEffect(() => {
    if (width < DRAWER_BREAKPOINT) {
      dispatch(closeTraceLogDrawer())
    }
  }, [width])

  return (
    isOpen && (
      <IncidentDrawerContainer width={TRACELOG_DRAWER_WIDTH}>
        <TraceLogContent incident={incident} />
      </IncidentDrawerContainer>
    )
  )
}
